import {Inject, Injectable} from '@angular/core';
import {first, take} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {AddressImport} from "../interface/address-import";
import {Observable, ReplaySubject} from "rxjs";
import {Uuid} from "../interface/response/uuid";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {ImportContact} from "../interface/import-contact";

@Injectable({
  providedIn: 'root'
})
export class ImportContactService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<ImportContact>>
    = new ReplaySubject<CountedAndPaginated<ImportContact>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadImportList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/import-contact?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ImportContact>) => {
        this.importListSubject.next(result);
      });
  }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/import-contact/method/import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public getImport(importId: string): Observable<ImportContact> {
    return this.httpClient.get(`/rest/crm/import-contact/${importId}`)
      .pipe(first()) as Observable<ImportContact>;
  }

  public downloadImportFile(importId: string): void {
    this.document.location.href = `/rest/crm/import-contact/${importId}/downloadFile`;
  }
}
